import React, { useEffect, useMemo } from 'react';
import DocumentActionsSection from 'components/common/documents-upload/DocumentActionsSection';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { observer } from 'mobx-react-lite';
import { DocumentList } from 'components/common/documents-upload/DocumentsList';

import { useDocumentsUploadUrlParams } from 'global/hooks/useDocumentsUploadUrlParams';
import { useHistory } from 'react-router-dom';

import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import {
  RFQ_PROPOSAL_CARD_DATA,
  getRFQProposalChecklistURL,
} from 'global/checklists-helpers/RFQProposalChecklistHelper';
import UploadResponseRFQDocumentsPageStore, {
  useUploadResponseRFQDocumentsPageStore,
  UploadResponseRFQDocumentsPageStoreContext,
} from 'store/pages/rfq/rfq-response/upload-response-rfq-documents/pageStore';
import PageFooter from 'components/common/general/layouts/PageFooter';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { InfoSection } from 'components/common/documents-upload/InfoSection';

const PageContent: React.FC = observer(() => {
  const pageStore = useUploadResponseRFQDocumentsPageStore();
  const { periodId } = useDocumentsUploadUrlParams();
  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  const history = useHistory();

  useEffect(() => {
    void pageStore.loadInitialData();
  }, []);

  const onBack = (): void => {
    const checklistURL = getRFQProposalChecklistURL({ periodId, cartId });
    history.push(checklistURL);
  };

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.RFQ_RESPONSE_DOCUMENTS.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.RFQ_RESPONSE_DOCUMENTS.text}
        subtitleMaxWidth="51rem"
        spacing="WITH_ACTION_BELOW"
        onRedirect={onBack}
      />
      {pageStore.activeDocuments.length > 0 && <InfoSection />}
      <DocumentActionsSection
        requestDocumentModalStore={pageStore.requestDocumentModalStore}
        uploadDocumentModalStore={pageStore.uploadDocumentModalStore}
        loading={pageStore.isPageLoading}
        disableMutativeActions={false}
      />
      <DocumentList
        activeDocuments={pageStore.activeDocuments}
        inactiveDocuments={pageStore.inactiveDocuments}
        loading={pageStore.isPageLoading}
      />
      <PageFooter disableCompleteButton onBack={onBack} />
    </>
  );
});

const ResponseRFQDocumentsPage: React.FC = () => {
  const { periodId } = useDocumentsUploadUrlParams();

  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  const pageStore = useMemo(
    () => new UploadResponseRFQDocumentsPageStore({ affiliatedId: periodId, entityId: cartId }),
    [],
  );

  return (
    <RFQStatusLayout>
      <UploadResponseRFQDocumentsPageStoreContext.Provider value={pageStore}>
        <PageContent />
      </UploadResponseRFQDocumentsPageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default ResponseRFQDocumentsPage;
